import { render } from 'preact';
import { HttpApi } from './api/client';
import { App } from './app';
import { canFly } from './lib/flight';
import { haptic } from './lib/haptics';
import { browserStorage, legacyKeys, Persist, storageKeys } from './lib/persist';
import { ControllerContext } from './state/context';
import { GameController } from './state/controller';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/game.css';
import './styles/modal.css';
import './styles/help.css';
import './styles/flight.css';

const storage = browserStorage();
const persist = new Persist(storage);
persist.migrateLegacy(legacyKeys(storage as (Storage & { length: number }) | null));
persist.migrateOldRecords(storageKeys(storage as (Storage & { length: number }) | null));

// Ссылка друга «/?b=<поле>» открывает то же поле; после этого параметр убираем, чтобы перезагрузка не возвращала к нему
const params = new URLSearchParams(location.search);
const initialBoard = params.get('b');
if (params.has('b')) {
  params.delete('b');
  const rest = params.toString();
  history.replaceState(null, '', `${location.pathname}${rest ? `?${rest}` : ''}${location.hash}`);
}

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const controller = new GameController({
  // VITE_API_BASE задаётся только при сборке мобильной оболочки (см. README)
  api: new HttpApi(import.meta.env.VITE_API_BASE ?? ''),
  persist,
  sleep: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
  animate: !reducedMotion,
  pollMs: 1000,
  now: () => Date.now(),
  haptic: (kind) => haptic(kind),
  // Нагрев летит к бомбе только там, где браузер умеет двигать элемент по пути (иначе просто число на шкале)
  flightMs: canFly() ? 900 : 0,
  initialBoard,
  shareUrl: (boardId) => `${location.origin}/?b=${encodeURIComponent(boardId)}`,
});

const root = document.getElementById('app');
if (!root) throw new Error('#app не найден');
render(
  <ControllerContext.Provider value={controller}>
    <App />
  </ControllerContext.Provider>,
  root,
);
